(function(){
  function addDateField(){
    // Only run on product pages
    if(!document.querySelector('.product-info'))return;
    // Don't add twice
    if(document.getElementById('date-required-field'))return;
    
    // Find the buy-buttons container inside the product form
    var buyBtns=document.querySelector('.product-info .buy-buttons');
    if(!buyBtns)return false;
    
    // Get the form this belongs to
    var form=buyBtns.closest('form');
    var formId=form?form.getAttribute('id'):'';
    
    // Create the date required container
    var container=document.createElement('div');
    container.style.cssText='margin-top:12px;margin-bottom:16px;';
    container.innerHTML='<label for="date-required-field" style="display:block;font-size:14px;font-weight:600;margin-bottom:6px;">Date Required:</label>'
      +'<input type="text" id="date-required-field" name="properties[Date Required]"'
      +(formId?' form="'+formId+'"':'')
      +' placeholder="e.g. 21/06/2025" style="width:100%;padding:10px 12px;border:1px solid #ccc;border-radius:6px;font-size:14px;background:#fff;box-sizing:border-box;">'
      +'<p style="margin-top:6px;margin-bottom:0;font-size:12px;color:#666;">Please let us know what day you need your order by.</p>';
    
    // Insert before the buy-buttons
    buyBtns.parentElement.insertBefore(container,buyBtns);
    return true;
  }
  
  // Try immediately and then with retries for dynamic loading
  var attempts=0;
  function tryAdd(){
    if(addDateField())return;
    if(attempts<20){attempts++;setTimeout(tryAdd,500);}
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',tryAdd);
  }else{
    tryAdd();
  }
})();